// extracted by mini-css-extract-plugin
export default {"style":"style___F7Z8Y"};